import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { loginAsync, postAsync } from '../../../components/helper/axiosHelper';
// import { login } from '../../../features/authSlice';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { useLocation } from 'react-use';
import LoadingAnimation from '../../../components/LoadingAnimation';
import { menucontrol } from '../../../features/togglebuttonSlice';
import { getStorage } from '../../../libs/getStorage';
import { PageHitCountApi } from '../../../shared/Helper';
// import { getStorage } from '../../../libs/getStorage';

const DonorLogin = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const dispatch = useDispatch();
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isload, setIsload] = useState(false);
  const [token, setToken] = useState('');
  const tokenStorage = localStorage.getItem('token');

  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();




  useEffect(() => {
    PageHitCountApi(pathname, 0);
  }, []);


  useEffect(() => {
    const handlePopState = (event) => {
      window.history.pushState(null, '', window.location.href);
    };

    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);


  useEffect(() => {
    localStorage.setItem('isHome', true);
    localStorage.removeItem('token');
    localStorage.removeItem('id');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('expirationDate');
    localStorage.removeItem('userName');
    localStorage.removeItem('name');
    localStorage.removeItem('role');
    localStorage.removeItem('email');
    localStorage.removeItem('statusCode');
    localStorage.removeItem('message');
    localStorage.removeItem('userId');
    localStorage.removeItem('expiry');
    localStorage.removeItem('otpToken');
    localStorage.removeItem('endTime');
    localStorage.removeItem('timerExpired');
  }, []);

  const body = {
    userName,
    password,
  };

  const otpgen = async (response) => {
    await postAsync(
      `EP_UserAuthentication/LoginOTPgenerator`,
      { userName: userName, isUserName: true },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
      .then((res) => {
        setIsload(false);
        navigate('/otp', { state: { loginData: response } });
      })
      .catch((err) => {
        setIsload(false);
        toast.error(`${t('msg_errorDueto')}` + ':' + err.message);
      });
  };

  const Login = (e) => {
    e.preventDefault();
    if (validate()) {
      setIsload(true);
      loginAsync('EP_UserAuthentication/EP_User_Login', body, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getStorage('token')}`,
        },
      })
        .then((response) => {

          if (response?.statusCode === 422) {
            toast.warning(`${t('Login Failed! Email/Mobile or Password is incorrect.')}`);
          } else {
            otpgen(response);
            // toast.success(`${t('msg_loginSuccess')}`);
            //dispatch(login(response));
            //setStorage(response, setToken);
            localStorage.setItem('isHome', true);
            localStorage.setItem('otpToken', response.token);
            dispatch(menucontrol(true));
            //window.location.href = '/user';
            // refreshing token
          }
        })
        .catch((err) => {
          setIsload(false);
          toast.error(`${t(`${err?.response?.data?.value}`)}`);
        });
    }
  };
  const validate = () => {
    let result = true;
    if (userName === '' || userName === null) {
      result = false;
      toast.warning(`${t('msg_username')}`);
    }
    if (password === '' || password === null) {
      result = false;
      toast.warning(`${t('msg_password')}`);
    }
    return result;
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      { isload ? (
        <LoadingAnimation
          imageStyling={ "" }
          styling={ "flex items-center  pt-20 xl:pt-32 pb-4 xl:pb-0 align-middle justify-center space-x-2" } />
      ) : (
        <div data-aos="zoom-in"
          data-aos-easing="linear"
          data-aos-duration="1500"
          className="pt-12 xl:pt-28 items-center">
          <div

            className="py-10"
            style={ {
              background: `transparent url('./assets/Sharjah-stroke-logo-1.png') left top 0px no-repeat`,

              width: '100%',
            } }
          >
            { ' ' }
          </div>
          <div className="container-fluid py-4">
            <div className="row justify-center items-center">
              <div className="col-sm-6 col-lg-4 ">
                <form onSubmit={ Login } className="">
                  <div className="card rounded-4xl shadow-customgreen bg-green-50">
                    <div className="card-body flex flex-col  gap-y-4">
                      <div className="row justify-center items-center">
                        <div className=" flex justify-center">
                          <div className="w-24 h-24  flex items-center justify-center rounded-full border-2 border-customgreen">
                            <svg
                              version="1.0"
                              xmlns="http://www.w3.org/2000/svg"
                              width="50.000000pt"
                              height="50.000000pt"
                              viewBox="0 0 290.000000 350.000000"
                              preserveAspectRatio="xMidYMid meet"
                            >
                              { ' ' }
                              <g
                                transform="translate(0.000000,300.000000) scale(0.050000,-0.050000)"
                                fill="#1d8b4b"
                                stroke="none"
                              >
                                { ' ' }
                                <path d="M2680 5960 c-187 -44 -329 -94 -420 -149 -38 -23 -97 -55 -129 -71 -110 -55 -416 -382 -498 -530 -629 -1145 264 -2509 1542 -2356 1139 136 1749 1342 1192 2356 -82 148 -388 475 -498 530 -32 16 -90 48 -129 72 -266 161 -728 226 -1060 148z" />{ ' ' }
                                <path d="M2370 2467 c-1099 -158 -1942 -1062 -1985 -2129 l-10 -251 55 -44 55 -43 2515 0 2515 0 55 43 55 44 -10 251 c-31 769 -460 1444 -1195 1876 -103 60 -365 158 -560 209 -164 42 -1273 75 -1490 44z" />{ ' ' }
                              </g>{ ' ' }
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div className="row justify-center items-center">
                        <div className="col-lg-6 w-auto text-center">
                          <h2 className="text-xl sm:text-2xl text-customgreen font-semibold">{ t('login_ep') }</h2>
                        </div>
                      </div>
                      <div className="form-group">
                        <label>
                          { t('username') }
                          <span className="errmsg">*</span>
                        </label>
                        <input
                          value={ userName }
                          onChange={ (e) => setUserName(e.target.value) }
                          placeholder={ t('username') }
                          className=" border border-customgreen focus:ring-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5"
                          type="text"
                          name="username"
                        />
                      </div>


                      <div className="form-group">
                        <label>
                          { t('password') }
                          <span className="errmsg">*</span>
                        </label>
                        <div style={ { position: 'relative', flex: 1 } }>
                          <input
                            value={ password }
                            onChange={ (e) => setPassword(e.target.value) }
                            placeholder={ t('password') }
                            className=" border border-customgreen focus:ring-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5"
                            type={ showPassword ? 'text' : 'password' }
                            name="password"
                          />
                          <button
                            type="button"
                            className={ `eye-button ${isActive ? 'left-1' : 'right-1'}` }
                            style={ {
                              backgroundColor: 'transparent',
                              border: '0',
                              position: 'absolute',

                              top: '50%',
                              transform: 'translateY(-50%)',
                            } }
                            onClick={ togglePasswordVisibility }
                          >
                            { showPassword ? <VisibilityIcon /> : <VisibilityOffIcon /> }
                          </button>
                        </div>
                      </div>
                      <div className=" form-group flex flex-col lg:flex-row gap-x-2 space-y-2 lg:space-y-0 justify-center items-center border-0">
                        <button
                          type="submit"
                          className="text-white  w-full bg-customgreen hover:bg-hovergreen font-medium rounded-full text-sm px-3 py-2 text-center transition duration-700 ease-in-out"
                        >
                          { t('login') }
                        </button>

                        <Link className="text-white  w-full bg-customgreen hover:bg-hovergreen font-medium rounded-full text-sm px-3 py-2 text-center hover:text-white transition duration-700 ease-in-out" to={ '/donorRegisteration' }>
                          { t('register') }
                        </Link>

                      </div>
                      <div className=" border-0">
                        <Link className='inline-block' to={ '/forgotpassword' } style={ { fontSize: '12px' } }>
                          { t('Forgot Password?') }
                        </Link>
                      </div>
                    </div>


                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
    // <div className=" items-center">
    //   <div
    //     className="py-10"
    //     style={{
    //       background: `transparent url('./assets/Sharjah-stroke-logo-1.png') left top 0px no-repeat`,

    //       width: '100%',
    //     }}
    //   >
    //     {' '}
    //   </div>
    //   <div className="container-fluid">
    //     <div className="row justify-center px-5 items-center">
    //       <div className="col-12 col-md-6 ">
    //         <form onSubmit={Login} className=" py-20">
    //           <div className="card rounded-4xl shadow-customgreen bg-green-50">
    //             <div className="card-body">
    //               <div className="row justify-center items-center">
    //                 <div className="col-lg-4 flex justify-center">
    //                   <div className="w-24 h-24 mb-3 flex items-center justify-center rounded-full border-2 border-customgreen">
    //                     <svg
    //                       version="1.0"
    //                       xmlns="http://www.w3.org/2000/svg"
    //                       width="50.000000pt"
    //                       height="50.000000pt"
    //                       viewBox="0 0 290.000000 350.000000"
    //                       preserveAspectRatio="xMidYMid meet"
    //                     >
    //                       {' '}
    //                       <g
    //                         transform="translate(0.000000,300.000000) scale(0.050000,-0.050000)"
    //                         fill="#1d8b4b"
    //                         stroke="none"
    //                       >
    //                         {' '}
    //                         <path d="M2680 5960 c-187 -44 -329 -94 -420 -149 -38 -23 -97 -55 -129 -71 -110 -55 -416 -382 -498 -530 -629 -1145 264 -2509 1542 -2356 1139 136 1749 1342 1192 2356 -82 148 -388 475 -498 530 -32 16 -90 48 -129 72 -266 161 -728 226 -1060 148z" />{' '}
    //                         <path d="M2370 2467 c-1099 -158 -1942 -1062 -1985 -2129 l-10 -251 55 -44 55 -43 2515 0 2515 0 55 43 55 44 -10 251 c-31 769 -460 1444 -1195 1876 -103 60 -365 158 -560 209 -164 42 -1273 75 -1490 44z" />{' '}
    //                       </g>{' '}
    //                     </svg>
    //                   </div>
    //                 </div>
    //               </div>
    //               <div className="row justify-center items-center">
    //                 <div className="col-lg-6 w-auto text-center">
    //                   <h2 className="text-xl sm:text-2xl text-customgreen font-semibold">{t('login_ep')}</h2>
    //                 </div>
    //               </div>
    //               <div className="form-group">
    //                 <label>
    //                   {t('username')}
    //                   <span className="errmsg">*</span>
    //                 </label>
    //                 <input
    //                   value={userName}
    //                   onChange={(e) => setUserName(e.target.value)}
    //                   placeholder={t('username')}
    //                   className=" border border-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5"
    //                   type="text"
    //                   name="username"
    //                 />
    //               </div>

    //               <div className="form-group">
    //                 <label>
    //                   {t('password')}
    //                   <span className="errmsg">*</span>
    //                 </label>
    //                 <div style={{ position: 'relative', flex: 1 }}>
    //                   <input
    //                     value={password}
    //                     onChange={(e) => setPassword(e.target.value)}
    //                     placeholder={t('password')}
    //                     className=" border border-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5"
    //                     type={showPassword ? 'text' : 'password'}
    //                     name="password"
    //                   />
    //                   <button
    //                     type="button"
    //                     className={`eye-button ${isActive ? 'left-1' : 'right-1'}`}
    //                     style={{
    //                       backgroundColor: 'transparent',
    //                       border: '0',
    //                       position: 'absolute',

    //                       top: '50%',
    //                       transform: 'translateY(-50%)',
    //                     }}
    //                     onClick={togglePasswordVisibility}
    //                   >
    //                     {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
    //                   </button>
    //                 </div>
    //               </div>
    //             </div>
    //             <div className="card-footer flex flex-col lg:flex-row space-y-2 lg:space-y-0 lg:space-x-2 justify-center items-center border-0">
    //               <button
    //                 type="submit"
    //                 className="text-white mx-1 w-4/5 bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2.5 text-center"
    //               >
    //                 {t('login')}
    //               </button>
    //               <button className="text-white mx-1 w-4/5 bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2.5 text-center">
    //                 <Link to={'/donorRegisteration'}>{t('register')}</Link>
    //               </button>
    //             </div>

    //             <div className="card-footer  border-0">
    //               <Link to={'/forgotpassword'} style={{ fontSize: '12px', backgroundColor: 'transparent' }}>
    //                 {t('Forgot Password?')}
    //               </Link>
    //             </div>
    //           </div>
    //         </form>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

export default DonorLogin;

// function setStorage(response, setToken) {
//   Object.keys(response).forEach((key) => {
//     localStorage.setItem(key, response[key]);
//     if (key === 'token') {
//       setToken(response[key]);
//     }
//   });
// }
